import React from 'react';

import Icon, { ICON_TYPES } from '@commons/Icon';

import { testName } from '@utils/testUtils';

import styles from './calendarTitle.scss';


interface CalendarTitleProps {
  calendarTitle?: string;
  prevMonthAriaLabel?: string;
  nextMonthAriaLabel?: string;
  onClickNextMonth?: (...args: unknown[]) => unknown;
  onClickPrevMonth?: (...args: unknown[]) => unknown;
  shouldShowNextMonthButton?: boolean;
}


export default function CalendarTitle(props: CalendarTitleProps) {
  const {
    calendarTitle,
    prevMonthAriaLabel,
    nextMonthAriaLabel,
    onClickNextMonth,
    onClickPrevMonth,
    shouldShowNextMonthButton
  } = props;

  return (
    <tr className={styles.calendarTitleContainer}>
      <td>
        <button
          aria-label={prevMonthAriaLabel}
          className={styles.prevMonthLink}
          onClick={onClickPrevMonth}
          {...testName('prev-month', 'button')}
        >
          <Icon type={ICON_TYPES.ARROW_LEFT} />
        </button>
      </td>
      <td className={styles.calendarTitleLabel} colSpan="5">
        {calendarTitle}
      </td>
      <td>
        {shouldShowNextMonthButton && (
          <button
            aria-label={nextMonthAriaLabel}
            className={styles.nextMonthLink}
            onClick={onClickNextMonth}
            {...testName('next-month', 'button')}
          >
            <Icon type={ICON_TYPES.ARROW_RIGHT} />
          </button>
        )}
      </td>
    </tr>
  );
}
